/* tslint:disable */
/* eslint-disable */
/**
 * Preowned Search Image
 * API of the **Search Engine** component that allows querying **Preowned** products by image. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: heliolrd@inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * Cached image-search page grouped by visual subfamily. It does not include cacheReference because the client already has it.
 * @export
 * @interface ImageSearchPageResponse
 */
export interface ImageSearchPageResponse {
    /**
     * Groups ordered by visual relevance for this cached page.
     * @type {Array<SubfamilyGroup>}
     * @memberof ImageSearchPageResponse
     */
    'subfamilyGroups': Array<SubfamilyGroup>;
}
/**
 * Product or product group candidate returned by image search, with the same identifier semantics as the group search response. Products are ordered by IA visual relevance inside each subfamily.
 * @export
 * @interface ImageSearchProduct
 */
export interface ImageSearchProduct {
    /**
     * Product or product group identifier as returned by the group search flow.
     * @type {number}
     * @memberof ImageSearchProduct
     */
    'id': number;
    /**
     * Indicates whether this candidate represents a product group.
     * @type {boolean}
     * @memberof ImageSearchProduct
     */
    'isGroup': boolean;
    /**
     * Business reference of the product group as returned by the group search flow.
     * @type {number}
     * @memberof ImageSearchProduct
     */
    'groupReference': number;
    /**
     * Type of group returned by the catalog enrichment.
     * @type {string}
     * @memberof ImageSearchProduct
     */
    'groupType'?: string | null;
    /**
     * Localized description of the product or product group.
     * @type {string}
     * @memberof ImageSearchProduct
     */
    'groupDescription'?: string | null;
    /**
     * Front image URL of the product or product group.
     * @type {string}
     * @memberof ImageSearchProduct
     */
    'groupFrontImage'?: string | null;
    /**
     * Localized title of the product or product group.
     * @type {string}
     * @memberof ImageSearchProduct
     */
    'groupTitle'?: string | null;
    /**
     * Store identifier where the product or group is available.
     * @type {number}
     * @memberof ImageSearchProduct
     */
    'store'?: number;
    /**
     * Available product sizes for the product or product group.
     * @type {Array<ProductSize>}
     * @memberof ImageSearchProduct
     */
    'sizes': Array<ProductSize>;
    /**
     * 
     * @type {ProductPrices}
     * @memberof ImageSearchProduct
     */
    'prices': ProductPrices;
    /**
     * Grid identifiers associated with the product or product group.
     * @type {Array<string>}
     * @memberof ImageSearchProduct
     */
    'grids': Array<string>;
    /**
     * Universes associated with the product or product group.
     * @type {Array<string>}
     * @memberof ImageSearchProduct
     */
    'universes': Array<string>;
}
/**
 * First image-search response grouped by visual subfamily, including a cache reference for subsequent pagination.
 * @export
 * @interface ImageSearchResponse
 */
export interface ImageSearchResponse {
    /**
     * Opaque reference for subsequent cached-page requests. Valid for approximately 10 minutes.
     * @type {string}
     * @memberof ImageSearchResponse
     */
    'cacheReference': string;
    /**
     * Groups ordered by visual relevance. Products inside each group are also ordered by visual relevance.
     * @type {Array<SubfamilyGroup>}
     * @memberof ImageSearchResponse
     */
    'subfamilyGroups': Array<SubfamilyGroup>;
}
/**
 * Problem detail response for Image Search errors.
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * Application error code or problem type.
     * @type {string}
     * @memberof ModelError
     */
    'type': string;
    /**
     * Short, human-readable summary of the problem.
     * @type {string}
     * @memberof ModelError
     */
    'title': string;
    /**
     * HTTP status code generated by the origin server.
     * @type {number}
     * @memberof ModelError
     */
    'status': number;
    /**
     * Human-readable explanation specific to this occurrence of the problem.
     * @type {string}
     * @memberof ModelError
     */
    'detail': string;
    /**
     * Timestamp when the error was generated.
     * @type {string}
     * @memberof ModelError
     */
    'timestamp'?: string;
    /**
     * Optional structured diagnostic data.
     * @type {{ [key: string]: any; }}
     * @memberof ModelError
     */
    'extraData'?: { [key: string]: any; };
}
/**
 * Monetary amount expressed in minor units.
 * @export
 * @interface ProductPriceDto
 */
export interface ProductPriceDto {
    /**
     * ISO 4217 currency code.
     * @type {string}
     * @memberof ProductPriceDto
     */
    'currency': string;
    /**
     * Monetary value expressed in minor units.
     * @type {number}
     * @memberof ProductPriceDto
     */
    'value': number;
    /**
     * Number of decimal digits used by the currency minor unit.
     * @type {number}
     * @memberof ProductPriceDto
     */
    'exponent': number;
}
/**
 * Minimum and maximum price range for a product or product group.
 * @export
 * @interface ProductPrices
 */
export interface ProductPrices {
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof ProductPrices
     */
    'min': ProductPriceDto;
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof ProductPrices
     */
    'max': ProductPriceDto;
}
/**
 * Aggregated size availability for a product or product group.
 * @export
 * @interface ProductSize
 */
export interface ProductSize {
    /**
     * Size identifier.
     * @type {number}
     * @memberof ProductSize
     */
    'id': number;
    /**
     * Number of product variants available for this size.
     * @type {number}
     * @memberof ProductSize
     */
    'count': number;
    /**
     * Indicates whether this size matched an explicit search hit.
     * @type {boolean}
     * @memberof ProductSize
     */
    'isHit': boolean;
}
/**
 * Products grouped by IA visual subfamily.
 * @export
 * @interface SubfamilyGroup
 */
export interface SubfamilyGroup {
    /**
     * Visual subfamily label from IA classification.
     * @type {string}
     * @memberof SubfamilyGroup
     */
    'subfamily': string;
    /**
     * Products belonging to this visual subfamily, ordered by visual relevance.
     * @type {Array<ImageSearchProduct>}
     * @memberof SubfamilyGroup
     */
    'products': Array<ImageSearchProduct>;
}

/**
 * IaImageSearchApi - axios parameter creator
 * @export
 */
export const IaImageSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
         * @summary Get a cached page of image search results
         * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index to retrieve from the cached result set
         * @param {number} [size] Number of products requested for the cached page
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageSearchCachedPage: async (cacheReference: string, storeId: number, page?: number, size?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cacheReference' is not null or undefined
            assertParamExists('getImageSearchCachedPage', 'cacheReference', cacheReference)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getImageSearchCachedPage', 'storeId', storeId)
            const localVarPath = `/api/v2/search/products/image/{cacheReference}`
                .replace(`{${"cacheReference"}}`, encodeURIComponent(String(cacheReference)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Performs an IA image search by uploading an image along with optional parameters such as `year`, `section`, `k`, `searchMode` and `maxDim`. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. 
         * @summary Search preowned products by image
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] Optional year metadata to include in product response enrichment.
         * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
         * @param {number} [k] Maximum number of products returned per visual subfamily.
         * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
         * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductsByImage: async (storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchProductsByImage', 'storeId', storeId)
            // verify required parameter 'uploadedImage' is not null or undefined
            assertParamExists('searchProductsByImage', 'uploadedImage', uploadedImage)
            const localVarPath = `/api/v2/search/products/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


            if (uploadedImage !== undefined) { 
                localVarFormParams.append('uploadedImage', uploadedImage as any);
            }
    
            if (year !== undefined) { 
                localVarFormParams.append('year', year as any);
            }
    
            if (section !== undefined) { 
                localVarFormParams.append('section', section as any);
            }
    
            if (k !== undefined) { 
                localVarFormParams.append('k', k as any);
            }
    
            if (searchMode !== undefined) { 
                localVarFormParams.append('searchMode', searchMode as any);
            }
    
            if (maxDim !== undefined) { 
                localVarFormParams.append('maxDim', maxDim as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IaImageSearchApi - functional programming interface
 * @export
 */
export const IaImageSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IaImageSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
         * @summary Get a cached page of image search results
         * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index to retrieve from the cached result set
         * @param {number} [size] Number of products requested for the cached page
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageSearchCachedPage(cacheReference: string, storeId: number, page?: number, size?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageSearchPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageSearchCachedPage(cacheReference, storeId, page, size, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Performs an IA image search by uploading an image along with optional parameters such as `year`, `section`, `k`, `searchMode` and `maxDim`. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. 
         * @summary Search preowned products by image
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] Optional year metadata to include in product response enrichment.
         * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
         * @param {number} [k] Maximum number of products returned per visual subfamily.
         * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
         * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProductsByImage(storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProductsByImage(storeId, uploadedImage, lang, year, section, k, searchMode, maxDim, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IaImageSearchApi - factory interface
 * @export
 */
export const IaImageSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IaImageSearchApiFp(configuration)
    return {
        /**
         * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
         * @summary Get a cached page of image search results
         * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [page] Zero-based page index to retrieve from the cached result set
         * @param {number} [size] Number of products requested for the cached page
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageSearchCachedPage(cacheReference: string, storeId: number, page?: number, size?: number, lang?: string, options?: any): AxiosPromise<ImageSearchPageResponse> {
            return localVarFp.getImageSearchCachedPage(cacheReference, storeId, page, size, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Performs an IA image search by uploading an image along with optional parameters such as `year`, `section`, `k`, `searchMode` and `maxDim`. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. 
         * @summary Search preowned products by image
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [year] Optional year metadata to include in product response enrichment.
         * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
         * @param {number} [k] Maximum number of products returned per visual subfamily.
         * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
         * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductsByImage(storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options?: any): AxiosPromise<ImageSearchResponse> {
            return localVarFp.searchProductsByImage(storeId, uploadedImage, lang, year, section, k, searchMode, maxDim, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IaImageSearchApi - interface
 * @export
 * @interface IaImageSearchApi
 */
export interface IaImageSearchApiInterface {
    /**
     * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
     * @summary Get a cached page of image search results
     * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index to retrieve from the cached result set
     * @param {number} [size] Number of products requested for the cached page
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaImageSearchApiInterface
     */
    getImageSearchCachedPage(cacheReference: string, storeId: number, page?: number, size?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ImageSearchPageResponse>;

    /**
     * Performs an IA image search by uploading an image along with optional parameters such as `year`, `section`, `k`, `searchMode` and `maxDim`. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. 
     * @summary Search preowned products by image
     * @param {number} storeId ID of the store this query is directed to
     * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [year] Optional year metadata to include in product response enrichment.
     * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
     * @param {number} [k] Maximum number of products returned per visual subfamily.
     * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
     * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaImageSearchApiInterface
     */
    searchProductsByImage(storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options?: AxiosRequestConfig): AxiosPromise<ImageSearchResponse>;

}

/**
 * IaImageSearchApi - object-oriented interface
 * @export
 * @class IaImageSearchApi
 * @extends {BaseAPI}
 */
export class IaImageSearchApi extends BaseAPI implements IaImageSearchApiInterface {
    /**
     * Returns a page of image-search results previously created by the image-search POST operation, using the opaque cache reference returned in that first response. This endpoint does not re-upload the image and does not re-run visual search. Products that are no longer visible are omitted while preserving the original visual-search order among visible products. If the cache reference expired, clients must repeat the POST image-search request. 
     * @summary Get a cached page of image search results
     * @param {string} cacheReference Opaque cache reference returned by the image-search POST response
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [page] Zero-based page index to retrieve from the cached result set
     * @param {number} [size] Number of products requested for the cached page
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaImageSearchApi
     */
    public getImageSearchCachedPage(cacheReference: string, storeId: number, page?: number, size?: number, lang?: string, options?: AxiosRequestConfig) {
        return IaImageSearchApiFp(this.configuration).getImageSearchCachedPage(cacheReference, storeId, page, size, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Performs an IA image search by uploading an image along with optional parameters such as `year`, `section`, `k`, `searchMode` and `maxDim`. The response includes products that are visually similar to the uploaded image, grouped by visual subfamily, and an opaque cache reference for browsing subsequent pages without uploading the image again. 
     * @summary Search preowned products by image
     * @param {number} storeId ID of the store this query is directed to
     * @param {File} uploadedImage Image file to be uploaded for the search. Supported formats are JPEG and PNG. Maximum size is 50MB.
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [year] Optional year metadata to include in product response enrichment.
     * @param {string} [section] Storefront section used to constrain visual search. Valid values are WOMAN, MAN and KID.
     * @param {number} [k] Maximum number of products returned per visual subfamily.
     * @param {string} [searchMode] Visual-search mode applied to the uploaded image. Valid values are crop and simple.
     * @param {number} [maxDim] Maximum image dimension used by the visual-search preprocessing pipeline. Valid values are 256, 512, 768 and 1024.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaImageSearchApi
     */
    public searchProductsByImage(storeId: number, uploadedImage: File, lang?: string, year?: number, section?: string, k?: number, searchMode?: string, maxDim?: number, options?: AxiosRequestConfig) {
        return IaImageSearchApiFp(this.configuration).searchProductsByImage(storeId, uploadedImage, lang, year, section, k, searchMode, maxDim, options).then((request) => request(this.axios, this.basePath));
    }
}


